import * as React from "react";
import './App.css';
import 'normalize.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Routes from './Pages/Components/Routes';

class App extends React.Component{

  render() {
    return (
        <Routes/>
    );
  }
}

export default App;
